import { toggleClass } from '@opten/dom/toggle-class';
import { EventDispatcher } from '@opten/events/event-dispatcher';
import { debounce } from '@opten/reactive/debounce';
import { PageRenderHelper } from './page-render-helper';

export class SectionScrollSlider {
	static onStateChange = new EventDispatcher<boolean>();
	isAnimating: boolean = false;
	isOpen: boolean = false;

	private readonly scrollTopDefaultOffset: number = 200;
	private scrollTop: number = window.scrollY;

	public input: HTMLInputElement;
	public sliderThumb: HTMLElement;

	constructor(public element: HTMLElement) {
		this.input = this.element.querySelector('input');
		this.sliderThumb = this.element.querySelector(
			'.js-scroll-slider-thumb'
		);

		this.onSliderChange(parseInt(this.input.value), false);
		this.input.addEventListener('change', (e: any) =>
			this.onSliderChange(e.target.value)
		);
		this.input.addEventListener('input', (e: any) =>
			this.onSliderInput(e.target.value)
		);

		['touchstart', 'mouseenter'].forEach(type =>
			this.input.addEventListener(
				type,
				(e: any) => (this.scrollTop = window.scrollY)
			)
		);
	}

	private onSliderInput(sliderValue: number): void {
		this.isAnimating = true;
		this.applyStyles(sliderValue);
		this.applyScrollPos(sliderValue);
	}

	private onSliderChange(sliderValue: number, fireEvents = true): void {
		let newValue: any = 0;
		if (sliderValue > 50) {
			newValue = 100;
		}

		this.input.value = newValue;
		this.applyStyles(newValue);
		this.applyScrollPos(newValue);

		if (newValue == 0) {
			this.closeScrollContainer(fireEvents);
		} else if (newValue == 100) {
			this.openScrollContainer(fireEvents);
		}
		this.isAnimating = false;
	}

	private applyStyles(sliderValue): void {
		toggleClass(document.body, 'content-is-open', sliderValue > 0);
		toggleClass(this.element, 'is-slided', sliderValue > 50);
		this.sliderThumb.style.left = `${sliderValue}%`;
	}

	private applyScrollPos(sliderValue: number): void {
		window.scrollTo({
			top:
				this.scrollTop == 0
					? sliderValue / 100 * this.scrollTopDefaultOffset
					: (this.scrollTop * sliderValue) / 100,
			behavior: 'auto'
		});
	}

	private openScrollContainer(fireEvents = true): void {
		this.isOpen = true;
		if (fireEvents) {
			SectionScrollSlider.onStateChange.dispatch(this.isOpen);
		}
	}

	private closeScrollContainer(fireEvents = true): void {
		this.isOpen = false;
		if (fireEvents) {
			SectionScrollSlider.onStateChange.dispatch(this.isOpen);
		}
	}

	public open(smooth?: boolean) {
		return new Promise<void>((resolve, reject) => {
			if (this.isAnimating) {
				return reject();
			}
			if (window.scrollY == 0 || this.isOpen == false) {
				this.isAnimating = true;
				window.scrollTo({
					top: this.scrollTopDefaultOffset,
					behavior: smooth ? 'smooth' : 'auto'
				});
				setTimeout(() => {
					this.onSliderChange(100);
					this.isAnimating = false;
					this.scrollTop = this.scrollTopDefaultOffset;
					resolve();
				}, 300);
			} else {
				resolve();
			}
		});
	}

	public close(smooth?: boolean) {
		debounce;
		return new Promise<void>((resolve, reject) => {
			if (this.isAnimating) {
				return reject();
			}
			if (window.scrollY > 0 || this.isOpen) {
				PageRenderHelper.prevUrl = undefined;
				this.isAnimating = true;
				window.scrollTo({
					top: 0,
					behavior: smooth ? 'smooth' : 'auto'
				});
				setTimeout(() => {
					this.onSliderChange(0);
					this.isAnimating = false;
					this.scrollTop = 0;
					resolve();
				}, 300);
			} else {
				resolve();
			}
		});
	}
}
